import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Captions successfully burned into video',
  name: 'caption_generation_completed',
  params: [
    {
      description: 'The id of the video',
      name: 'video_id',
      required: true,
      type: 'string',
    },
    {
      description: 'Duration of the video in seconds',
      name: 'duration_seconds',
      required: true,
      type: 'number',
    },
    {
      description: 'JSON-stringified caption style configuration',
      name: 'style_config',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
